import { createFileRoute } from '@tanstack/react-router';
import { DataPage } from '@/features/organization/data/data-page';

export const Route = createFileRoute('/_app/o/$organizationId/settings/data')({
    staticData: { crumbs: [{ label: 'settings.nav.data' }] },
    component: function DataRoute() {
        const { organizationId } = Route.useParams();
        return <DataPage organizationId={organizationId} />;
    },
});
